

import { Options, Vue } from "vue-class-component";
import { isNewBridgeView } from '@/assets/js/utils.js'
import { goLogin } from '@/utils/nativeFn'

@Options({
  components: {},
})
export default class Success extends Vue {
  mounted() {
    
  }
  goNativeLogin() {
    let data = {
      type: 'destroy_account'
    }
    if (isNewBridgeView()) {
      goLogin(data, (res) => {
        console.log('跳转登录页', res)
      })
      return
    }
    window['$mobileNativeSDK'].goLogin(data)
  }
}
